<template>
    <svg :width="width ?? '24'" :height="height ?? '24'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" transform="matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)">
        <path
            d="M20.2959 9.79592L12.7959 17.2959C12.6914 17.4008 12.5672 17.484 12.4304 17.5408C12.2937 17.5976 12.1471 17.6268 11.999 17.6268C11.851 17.6268 11.7043 17.5976 11.5676 17.5408C11.4309 17.484 11.3067 17.4008 11.2021 17.2959L3.70215 9.79592C3.4908 9.58457 3.37207 9.29793 3.37207 8.99904C3.37207 8.70016 3.4908 8.41351 3.70215 8.20217C3.91349 7.99082 4.20014 7.87209 4.49902 7.87209C4.79791 7.87209 5.08455 7.99082 5.2959 8.20217L12 14.9062L18.704 8.20123C18.9154 7.98989 19.202 7.87115 19.5009 7.87115C19.7998 7.87115 20.0864 7.98989 20.2978 8.20123C20.5091 8.41258 20.6278 8.69922 20.6278 8.99811C20.6278 9.29699 20.5091 9.58364 20.2978 9.79498L20.2959 9.79592Z"
            fill="currentColor"
        />
    </svg>
</template>

<script lang="ts" setup>
defineProps<{
  width?: string,
  height?: string,
}>()
</script>
